import {IRouteProps} from "../../../../ts/manager/view/ViewInterface";
import {getManager} from "../../../../ts/manager/Manager";
import StateViewController from "../../../vc/StateViewController";
import {assert} from "../../../../ts/common/Assert";
import React, {useState} from "react";
import RoutePagination from "../../../element/RoutePagination";
import {IonCard, IonCardContent, IonInfiniteScroll, IonInfiniteScrollContent} from "@ionic/react";
import {getModelFactory} from "../../../../ts/model-factory/ModelFactory";
import RouteChoiceButton from "../../../element/button/RouteChoiceButton";
import {dateFormat} from "../../../../ts/common/DateFormat";
import {MessageDataChoice} from "../../../../ts/data/subject/message/MessageDataFactory";
import {IonInfiniteScrollCustomEvent} from "@ionic/core/dist/types/components";
import SearchViewModel from "../../search/SearchViewModel";
import LoadingPartial from "../../../partial/status/LoadingPartial";

const MessagePageListPage = (props:IRouteProps) =>
{

    const primaryPageNumber = parseInt(getManager().navigation.model.routeIDs.message_page_list_route_id ?? "1")

    const [viewModel] = useState<SearchViewModel>(() => {
        return new SearchViewModel();
    });

    viewModel.populate({
        pageListRouteModel: getManager().navigation.model.routeModels.messagePageList,
        primaryPageNumber: primaryPageNumber
    });

    const pageListRouteModel = viewModel.pageListRouteModel;
    const messageListRouteModel = getModelFactory().messageListRoute.getDefaultModel();

    const primaryPageModel = viewModel.getPrimaryPageModel();
    const [, setSimpleState] = useState<any[]>([]);


    const viewState = StateViewController({
        routeProps: props,
        assert: [pageListRouteModel, primaryPageModel, messageListRouteModel],
        dataModels: [primaryPageModel]
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }

    assert(pageListRouteModel);
    assert(primaryPageModel);
    assert(messageListRouteModel);


    viewModel.requireInitialized().then((didInitialize:boolean) => {
        if(didInitialize){
            setSimpleState([]);
        }
    })
    if(!viewModel.initialized){
        return <LoadingPartial {...props} />;
    }

    viewModel.update();

    const pageChoiceList = viewModel.pageChoiceList;
    const messageChoiceList = viewModel.itemChoiceList as MessageDataChoice[];
    const pageChoice = viewModel.pageChoice;

    const usePages = viewModel.usePages;
    const showPages = viewModel.showPages;
    const showInfiniteScroll = viewModel.showInfiniteScroll;
    const numberOfEntries = viewModel.numberOfEntries;

    const onInfiniteScrollNext = (event:IonInfiniteScrollCustomEvent<void>) =>{
        viewModel.checkAddNextInfiniteScrollPage((completed) => {
            if(completed){
                setSimpleState([])
                event.target.complete();
            }
        })
    }

    return <>
        <section className="content-block">
            <div
                className="container"
                data-route-view={pageChoice?.realPath}
            >
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 text-end">
                                <p className="smaller mb-2">
                                    {numberOfEntries > 1 ? numberOfEntries+" messages" : (numberOfEntries ? "1 message" : "No messages")}
                                </p>
                            </div>
                        </div>
                        {usePages && <>
                            <div className={"row" + (!showPages ? " appear-hidden" : "")}>
                                <div className="col-12 text-end">
                                    <RoutePagination choiceList={pageChoiceList} />
                                </div>
                            </div>
                        </>}
                        <div className="row mt-4">
                            <div className="col-12">

                                {messageChoiceList.map((message, index) =>
                                {

                                    const routeChoice = messageListRouteModel.choices[message.id];
                                    if(!routeChoice){
                                        return ""
                                    }
                                    return <IonCard
                                        key={message.id}
                                    >
                                        <IonCardContent className="py-4">
                                            <div className="row">
                                                <div className="col-2">
                                                    {message.created ? dateFormat(message.created , {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                    }) : ""}
                                                </div>
                                                <div className="col-7">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <p>{message.title}</p>
                                                        </div>
                                                        <div className="col-12">
                                                            <p className="smaller"><strong>From:</strong> {message.fromUser.getName()}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-3 text-end">
                                                    <RouteChoiceButton
                                                        routeChoice={routeChoice}
                                                        label="View"
                                                        className="btn btn-primary"
                                                    />
                                                </div>
                                            </div>
                                        </IonCardContent>
                                    </IonCard>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                {showInfiniteScroll && <>
                    <IonInfiniteScroll
                        onIonInfinite={onInfiniteScrollNext}
                    >
                        <IonInfiniteScrollContent loadingText="Please wait..." loadingSpinner="bubbles"></IonInfiniteScrollContent>
                    </IonInfiniteScroll>
                </>}
            </div>
        </section>
    </>
}

export default MessagePageListPage;